import { render, staticRenderFns } from "./FixDisc.vue?vue&type=template&id=4602e720"
import script from "./FixDisc.vue?vue&type=script&lang=js"
export * from "./FixDisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports